import React, { useState, useRef } from 'react';
import { Card } from 'primereact/card';
import { Avatar } from 'primereact/avatar';
import { Button } from 'primereact/button';
import axios from 'axios';
import { url, api } from '../../../../env';

export default function UserDashboardSidebar({ user, car, onPhotoUpdate, toast }) {
    const fileInputRef = useRef(null);
    const [uploading, setUploading] = useState(false);

    const handlePhotoClick = () => {
        fileInputRef.current.click();
    };

    const handleFileChange = async (event) => {
        const file = event.target.files[0];
        if (!file) return;

        if (!file.type.startsWith('image/')) {
            toast.current.show({ severity: 'error', summary: 'Error', detail: 'Por favor selecciona una imagen válida' });
            return;
        }

        const formData = new FormData();
        formData.append('photo', file);

        setUploading(true);
        try {
            const response = await axios.post(`${url}/user-dashboard/update-photo`, formData, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                    Authorization: `Bearer ${localStorage.getItem('token')}`,
                    Accept: 'application/json'
                }
            });

            if (response.data.success) {
                toast.current.show({ severity: 'success', summary: 'Éxito', detail: 'Foto de perfil actualizada' });
                onPhotoUpdate();
            }
        } catch (error) {
            console.error('Error uploading photo:', error);
            toast.current.show({ severity: 'error', summary: 'Error', detail: 'No se pudo subir la foto' });
        } finally {
            setUploading(false);
        }
    };

    return (
        <div className="sidebar-container">
            <Card className="surface-section shadow-1 border-none">
                <div className="flex flex-column align-items-center mb-4">
                    <div className="relative group cursor-pointer" onClick={handlePhotoClick}>
                        <Avatar
                            image={user?.profile_photo_url || 'https://www.gravatar.com/avatar/00000000000000000000000000000000?d=mp&f=y'}
                            size="xlarge"
                            shape="circle"
                            className="w-8rem h-8rem shadow-3 border-2 border-white"
                        />
                        <div className="absolute bottom-0 right-0 bg-white border-circle p-2 shadow-2">
                            <i className={`pi ${uploading ? 'pi-spin pi-spinner' : 'pi-camera'} text-blue-500`}></i>
                        </div>
                        <input
                            type="file"
                            ref={fileInputRef}
                            style={{ display: 'none' }}
                            onChange={handleFileChange}
                            accept="image/*"
                        />
                    </div>
                    <h2 className="text-xl font-bold mt-3 mb-1 text-center">{user?.name}</h2>
                    <span className="text-gray-500 text-sm">{user?.email}</span>
                </div>

                <div className="border-top-1 border-gray-200 pt-3 mt-3">
                    <h3 className="text-sm font-semibold text-gray-500 mb-3 uppercase tracking-wider">Mi Plan Peicar</h3>

                    <div className="flex flex-column gap-3">
                        <div className="flex align-items-center gap-3">
                            <i className="pi pi-car text-blue-500 text-lg"></i>
                            <div>
                                <span className="block text-xs text-gray-400">VEHÍCULO</span>
                                <span className="font-semibold text-sm">{car?.brand} {car?.model}</span>
                            </div>
                        </div>

                        <div className="flex align-items-center gap-3">
                            <i className="pi pi-calendar text-blue-500 text-lg"></i>
                            <div>
                                <span className="block text-xs text-gray-400">AÑO</span>
                                <span className="font-semibold text-sm">{car?.year}</span>
                            </div>
                        </div>

                        <div className="flex align-items-center gap-3">
                            <i className="pi pi-wallet text-blue-500 text-lg"></i>
                            <div>
                                <span className="block text-xs text-gray-400">PRECIO</span>
                                <span className="font-semibold text-sm">
                                    {new Intl.NumberFormat('es-MX', { style: 'currency', currency: 'MXN' }).format(car?.price || 0)}
                                </span>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="mt-5">
                    <Button
                        label="Cerrar Sesión"
                        icon="pi pi-power-off"
                        className="p-button-text p-button-danger w-full justify-content-start"
                        onClick={() => {
                            localStorage.removeItem('token');
                            window.location.href = '/login';
                        }}
                    />
                </div>
            </Card>
        </div>
    );
}
